import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Welcome = () => import('src/pages/Welcome.vue');


let routes = [], base = "/sign-up";

if (window.location.pathname.indexOf("/sign-up") === 0) {
  
  routes = [
    
    {
      path: '/',
      name: "Dashboard",
      component: {
        template: '<router-view/>'
      },
      redirect: '/welcome',
      children: [
        {
          path: "welcome/:plan?",
          name: "Welcome",
          props: true,
          component: Welcome
        }
      ]
    },
    
    {
      path: "*", component: {
        template: "",
        created: function () {
          window.location.href = "/404";
        }
      }
    }
  ];
}

export default new VueRouter({
  mode: "history",
  base,
  routes,
  linkActiveClass: 'active'
});
